export const performanceProgressData = [
    {
        performanceProgress: 'ปริมาณขาย',
        quantity: 'ตัน',
        January: '151,888',
        February: '138,307',
        March: '156,697',
        April: '165,091',
        May: '160,129',
        June: '162,066',
        July: '165,080',
        August: '171,144',
        September: '159,752',
        October: '166,937',
        November: '170,548',
        December: '176,684',
        total: '1,944,322',
    },
    {
        performanceProgress: 'มูลค่าขาย',
        quantity: 'ล้านบาท',
        January: ' 2,237',
        February: '2,033',
        March: '2,373',
        April: '2,558',
        May: '2,550',
        June: '2,629',
        July: '2,725',
        August: '2,882',
        September: '2,725',
        October: '2,852',
        November: '2,917',
        December: '3,038',
        total: '31,519',
    },
    {
        performanceProgress: 'ราคาขาย',
        quantity: 'บาท/ก.ก.',
        January: '14.7',
        February: '14.7',
        March: '15.1',
        April: '15.5',
        May: '15.9',
        June: '16.22',
        July: '16.5',
        August: '16.8',
        September: '17.1',
        October: '17.1',
        November: '17.1',
        December: '17.2',
        total: '16.2',
    },
    {
        performanceProgress: 'ต้นทุนรวม',
        quantity: 'บาท/ก.ก.',
        January: '(13.5)',
        February: '(13.8)',
        March: '(14.2)',
        April: '(14.3)',
        May: '(14.7)',
        June: '(15.3)',
        July: '(15.8)',
        August: '(15.8)',
        September: '(15.7)',
        October: '(15.7)',
        November: '(15.6)',
        December: '(15.9)',
        total: '(15.1)',
    },
    {
        performanceProgress: 'กำไรสุทธิ',
        quantity: 'บาท/ก.ก.',
        January: '1.2',
        February: '0.9',
        March: '1.0',
        April: '1.2',
        May: '1.2',
        June: '0.9',
        July: '0.7',
        August: '1.0',
        September: '1.4',
        October: '1.4',
        November: '1.5',
        December: '1.3',
        total: '1.1',
    },
    {
        performanceProgress: '',
        quantity: 'ล้านบาท',
        January: '181',
        February: '131',
        March: '149',
        April: '192',
        May: '198',
        June: '148',
        July: '115',
        August: '173',
        September: '218',
        October: '231',
        November: '261',
        December: '234',
        total: '2,233',
    },
    {
        performanceProgress: '',
        quantity: '%',
        January: '8.1%',
        February: '6.4%',
        March: '6.3%',
        April: '7.5%',
        May: '7.8%',
        June: '5.6%',
        July: '4.2%',
        August: '6.0%',
        September: '8.0%',
        October: '8.1%',
        November: '9.0%',
        December: '7.7%',
        total: '7.1%',
    },
]